// import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {
  atomButtonColors,
  atomButtonDesigns,
  atomButtonShapes,
  atomButtonSizes
} from '@s-ui/react-atom-button'
import AtomImage from '@s-ui/react-atom-image'
import MoleculeNotification, {
  moleculeNotificationAlignItems,
  moleculeNotificationBorderSizes,
  moleculeNotificationTypes,
  moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'
import IconCheck from '@adv-mt/mt-svg-icons/lib/CircleCheck.js'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {BASE_CLASS_NAME} from '../config.js'

// TODO: Move this component to EmptyCase context --> https://jira.ets.mpi-internal.com/browse/MTR-103516

const EmptyRatingState = ({ctaAction, ctaText, description, imageUrl, notificationText, title}) => {
  return (
    <div className={`${BASE_CLASS_NAME}-emptyState`}>
      <div className={`${BASE_CLASS_NAME}-emptyStateContent`}>
        {notificationText && (
          <MoleculeNotification
            alignItems={moleculeNotificationAlignItems.CENTER}
            autoClose={null}
            icon={<IconCheck size="medium" />}
            position="relative"
            roundedCorners={moleculeNotificationBorderSizes.medium}
            show
            showCloseButton={false}
            showLeftIconMobile
            type={moleculeNotificationTypes.success}
            variation={moleculeNotificationVariations.positive}
          >
            {notificationText}
          </MoleculeNotification>
        )}
        <TitleBasic
          as={titleBasicTags.h1}
          className={`${BASE_CLASS_NAME}-emptyStateContentTitle`}
          size={titleBasicSizes.s}
          title={title}
        />
        {description && <span className={`${BASE_CLASS_NAME}-emptyStateContentDescription`}>{description}</span>}
        <div className={`${BASE_CLASS_NAME}-emptyStateContentImageMobile`}>
          <AtomImage src={imageUrl} />
        </div>
        <div className={`${BASE_CLASS_NAME}-emptyStateContentButton`}>
          <AtomButton
            design={atomButtonDesigns.SOLID}
            color={atomButtonColors.PRIMARY}
            shape={atomButtonShapes.CIRCULAR}
            size={atomButtonSizes.LARGE}
            onClick={ctaAction}
            fullWidth
          >
            {ctaText}
          </AtomButton>
        </div>
      </div>
      <div className={`${BASE_CLASS_NAME}-emptyStateImage`}>
        <AtomImage src={imageUrl} />
      </div>
    </div>
  )
}

EmptyRatingState.displayName = 'EmptyRatingState'

EmptyRatingState.propTypes = {
  ctaAction: PropTypes.func,
  ctaText: PropTypes.string,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
  notificationText: PropTypes.string,
  title: PropTypes.string
}

export default EmptyRatingState
